import {
  WechatInitOptions,
  OpenCheckInDataType,
  AppChat,
  AppChatInfo,
  WechatTextMsg,
  AppChatMsg
} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {TokenService} from "../../token/tokenservice";
import {ApprovalTokenService} from "../../token/approvaltokenservice";
import {AppTokenService} from "../..";

/**
 * 企业微信 群聊 服务
 */
export class AppChatService {

  /*
   * 创建群聊会话
   * */
  static async createAppChat(appChat: AppChat): Promise<string> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}appchat/create?access_token=${accessToken}`,
      body: appChat,
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result.chatid;
    } else {
      console.error(`create app chat failed , response:`);
      console.error(result);
    }

    return "";
  }

  /**
   * 修改群聊
   * @param appChat
   */
  static async updateAppChat(appChat: AppChatInfo): Promise<boolean> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}appchat/update?access_token=${accessToken}`,
      body: appChat,
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return true;
    } else {
      console.error(`update app chat failed , response:`);
      console.error(result);
    }

    return false;
  }


  /**
   * 获取群聊信息
   */
  static async getAppChat(chatId: string): Promise<AppChat> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "GET",
      uri: `${wechatOptions.corp.apiUrl}appchat/get?access_token=${accessToken}&chatid=${chatId}`,
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result.chat_info;
    } else {
      console.error(`get app chat failed , response:`);
      console.error(result);
    }

    return null;
  }

  /**
   * 发送消息
   * @param chatId
   * @param appChat
   */
  static async appChatSendTextMsg(appChatMsg: AppChatMsg): Promise<boolean> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}appchat/send?access_token=${accessToken}`,
      body: {
        "chatid": appChatMsg.chatid,
        "msgtype": appChatMsg.msgtype
      },
      json: true
    };

    param.body[appChatMsg.msgtype] = {content: appChatMsg.content};
    if (appChatMsg.msgtype !== "markdown") {
      param.body.safe = appChatMsg.safe || 0;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return true;
    } else {
      console.error(`send app chat message failed , response:`);
      console.error(result);
    }

    return false;
  }

}
